import { SET_HELP_MODE_STEP } from "./constants";

export const setHelpModeStep = (helpModeStep) => ({
    type: SET_HELP_MODE_STEP,
    payload: helpModeStep
});
